import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { useFormik } from "formik";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { toast } from "react-toastify";
import ApiService from "../../services/ApiService";
import { ShowErrorToast, ShowSuccessToast } from '../../components/toaster/toast.jsx';

const LoginPage = () => {
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
      // rememberMe: false,
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email format")
        .required("Email is required"),
      password: Yup.string()
        .min(5, "Password must be at least 5 characters")
        .required("Password is required"),
    }),
    onSubmit: async (values) => {
      setLoading(true); // Start loading
      try {
        const res = await ApiService.login(values);

        if(res.status == 200){
          // console.log("token",res.data.token)
          localStorage.setItem("token", res.data.token)
        
          ShowSuccessToast(`Welcome, ${res.data.username}!`);
          navigate('/dashboard')
        }

        // if (res.user.role == "Client") {
        //     navigate("/client/home")
        // } else if (res.user.role == "Agent") {
        //     navigate("/agent/home")
        // } else {
        //     navigate("/")
        // }
      } catch (error) {
        console.log("error", error);
        ShowErrorToast(
          error?.response?.data?.error ||
            "Something went wrong, please try again!"
        );
      } finally {
        setLoading(false); // Stop loading
      }
    },
  });

  const handleForgotPassword = () => {
    navigate("/forgot-password");
  };

  return (
    <>
      <div className="flex flex-col bg-custom-gradient text-white h-screen">
        {/* Header */}
        <div className="px-10 py-3 w-full flex items-center">
          <img
            src="/images/cards/pacific.png"
            alt="Company Logo"
            className="h-[75px] w-[100px]"
          />
        </div>

        {/* Main Content */}
        <div className="flex flex-col md:flex-row gap-10 lg:gap-40 md:gap-20 md:items-start sm:items-center justify-center flex-grow pt-5 xl:pt-10 2xl:pt-32 md:px-0 px-6">
          <div className="xl:my-auto">
            <h1 className="md:text-4xl text-2xl font-semibold mb-4 xl:mb-28">
              Login into <br /> your account
            </h1>
          </div>

          <div className="w-full flex flex-col max-w-md bg-white text-gray-900 p-8 rounded-lg shadow-lg">
            <form onSubmit={formik.handleSubmit} className="space-y-5 ">
              <div>
                <label className="block text-sm font-medium mb-2">Email</label>
                <input
                 name="email"
                  type="email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder="example@mail.com"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 placeholder:text-[#C8C8C8]"
                />
                {formik.touched.email && formik.errors.email && (
                  <p className="text-red-500 text-sm">{formik.errors.email}</p>
                )}
              </div>

              <div>
                <label className="block text-sm font-medium mb-2">
                  Password
                </label>
                <div className="relative">
                  <input
                    name="password"
                    type={showPassword ? "text" : "password"} // Toggle input type
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    placeholder="••••••••"
                    className={`w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 placeholder:text-[#C8C8C8]`}
                  />
                  <span
                    onClick={() => setShowPassword(!showPassword)} // Toggle visibility
                    className="absolute inset-y-0 right-3 flex items-center cursor-pointer text-gray-500"
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </span>
                </div>
                  {formik.touched.password && formik.errors.password && (
                  <p className="text-red-500 text-sm mt-1">{formik.errors.password}</p>
                )}
              </div>

              <div className="text-right">
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handleForgotPassword();
                  }}
                  className="text-sm text-[#4E4E4E] hover:underline focus:outline-none"
                >
                  Forgot password?
                </a>
              </div>

              <div className="flex justify-end">
                <button
                  type="submit"
                  disabled={loading}
                  className="md:w-[30%] w-full bg-orangeColor text-white px-4 py-1.5 rounded-lg flex justify-center items-center focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  {loading ? (
                    <svg
                      className="animate-spin h-5 w-5 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v8H4z"
                      ></path>
                    </svg>
                  ) : (
                    "Login"
                  )}
                </button>
              </div>
            </form>
          </div>
          <img
            src="/images/sitar.png"
            alt="Sitar"
            className="absolute bottom-0 left-0 hidden md:block"
          />
        </div>

        {/* Footer */}
        <footer className="sticky bottom-0 text-center py-4 w-full  text-white">
          © 2025 Pacific Cross. All Rights Reserved.
        </footer>
      </div>
    </>
  );
};

export default LoginPage;
